import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE, FICHIER_BASE } from 'config/apiConfig';

const baseURL = FICHIER_BASE;   // .../api/fichier (depuis .env via config/apiConfig)
const apiBase = API_BASE;        // .../api

const authConfig = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// (ancien) lancement SYNCHRONE — conservé en repli
export const createOptimisation = createAsyncThunk('optimisation/createOptimisation', async ({ projectId }, thunkAPI) => {
  const { rejectWithValue, getState } = thunkAPI;
  try {
    const res = await axios.post(
      baseURL + '/optimisation/' + projectId,
      { import_options: getState()?.optimisation?.importOptions || null },
      authConfig()
    );
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

// NOUVEAU : lance le nesting EN TÂCHE DE FOND -> { job_id }
export const startOptimisation = createAsyncThunk('optimisation/start', async ({ projectId }, thunkAPI) => {
  const { rejectWithValue, getState } = thunkAPI;
  try {
    const res = await axios.post(
      apiBase + '/optimisation/' + projectId + '/start',
      { import_options: getState()?.optimisation?.importOptions || null },
      authConfig()
    );
    return res.data; // { job_id }
  } catch (error) {
    return rejectWithValue(error.response?.data?.detail || error.response?.data?.message || error.message);
  }
});

// NOUVEAU : interroge l'état d'un job de nesting
export const pollOptimisationJob = createAsyncThunk('optimisation/poll', async ({ jobId }, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const res = await axios.get(apiBase + '/optimisation/job/' + jobId, authConfig());
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.detail || error.message);
  }
});

// NOUVEAU : demande l'annulation d'un job
export const cancelOptimisationJob = createAsyncThunk('optimisation/cancel', async ({ jobId }, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    await axios.post(apiBase + '/optimisation/job/' + jobId + '/cancel', {}, authConfig());
    return true;
  } catch (error) {
    return rejectWithValue(error.response?.data?.detail || error.message);
  }
});

export const optimisationSlice = createSlice({
  name: 'optimisation',
  initialState: {
    optimisations: [],
    status: null,
    error: null,
    nestingActive: false,   // un job est en cours -> affiche l'overlay de progression
    jobId: null,
    job: null,              // dernier état reçu { phase, percent, message, placed, total, plates, efficiency, boxes, plate_w, plate_h, done, error }
    importOptions: {
      tiny_on: true, tiny_tol: 0.1,
      smooth_on: true, smooth_tol: 0.05,
      merge_tol: 0.01,
      dedup_on: true, dedup_tol: 0.01,
      distinguish: true,
      auto_sort: true
    }
  },
  reducers: {
    setImportOptions: (state, action) => {
      state.importOptions = { ...state.importOptions, ...action.payload };
    },
    clearNesting: (state) => {
      state.nestingActive = false;
      state.jobId = null;
      state.job = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOptimisation.fulfilled, (state, action) => {
        state.optimisations.push(action.payload);
        state.status = 'success';
        state.error = null;
      })
      .addCase(createOptimisation.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createOptimisation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(startOptimisation.fulfilled, (state, action) => {
        state.jobId = (action.payload && action.payload.job_id) || null;
        state.nestingActive = true;
        state.error = null;
        state.job = {
          phase: 'queued', percent: 0, message: 'En attente...',
          placed: 0, total: 0, plates: 0, efficiency: 0, boxes: [], done: false
        };
      })
      .addCase(startOptimisation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        state.nestingActive = false;
      })
      .addCase(pollOptimisationJob.fulfilled, (state, action) => {
        state.job = action.payload;
      });
  }
});

export const { setImportOptions, clearNesting } = optimisationSlice.actions;
export default optimisationSlice.reducer;
